import React from 'react';
import FormikTextField from 'catalyst/core/form/TextField/variants/FormikTextField';
import FormikSelect from 'catalyst/core/form/Select/variants/FormikSelect';
import { isEmpty } from 'utils/Helper';

const FormikSelectFallBack = ({ list, ...rest }) => {
    return isEmpty(list) ? (
        <FormikTextField type="text" variant="outlined" fullWidth {...rest} />
    ) : (
        <FormikSelect items={list} fullWidth {...rest} />
    );
};

export default FormikSelectFallBack;
